import { Sky } from 'three/examples/jsm/objects/Sky.js'
import * as THREE from 'three'
import House from './House.js'
import Land from './Land.js'

export default class World extends THREE.Object3D {
    constructor(scene) {
        super(scene);
        this.scene = scene;
        this.house = new House();
        this.land = new Land();
        this.ghosts = [];
    }

    init() {
        this._createSky();
        this._createLights();
        this.scene.add(this.house, this.land)
    }
    
    moveGhosts(elapsedTime) {
        const ghost1Angle = elapsedTime * 0.5
        this.ghosts[0].position.x = Math.cos(ghost1Angle) * 4
        this.ghosts[0].position.z = Math.sin(ghost1Angle) * 4
        this.ghosts[0].position.y = Math.sin(ghost1Angle) * Math.sin(ghost1Angle * 2.34) * Math.sin(ghost1Angle * 3.45)

        const ghost2Angle = - elapsedTime * 0.8
        this.ghosts[1].position.x = Math.cos(ghost2Angle) * 5
        this.ghosts[1].position.z = Math.sin(ghost2Angle) * 5
        this.ghosts[1].position.y = Math.sin(ghost2Angle) * Math.sin(ghost2Angle * 2.34) * Math.sin(ghost2Angle * 3.45)

        const ghost3Angle = - elapsedTime * 0.75
        this.ghosts[2].position.x = Math.cos(ghost3Angle) * 6
        this.ghosts[2].position.z = Math.sin(ghost3Angle) * 6
    }

    _createSky() {
        const sky = new Sky();
        sky.scale.setScalar(100);
        
        sky.material.uniforms['turbidity'].value = 10;
        sky.material.uniforms['rayleigh'].value = 3;
        sky.material.uniforms['mieCoefficient'].value = 0.1;
        sky.material.uniforms['mieDirectionalG'].value = 0.95;
        sky.material.uniforms['sunPosition'].value.set(0.3, -0.3, -0.95);

        this.scene.fog = new THREE.Fog('#04343f', 1, 11);

        this.scene.add(sky);
    }

    _createLights() {
        const ambientLight = new THREE.AmbientLight('#86cdff', 0.275)

        const directionalLight = new THREE.DirectionalLight('#86cdff', 1)
        directionalLight.position.set(3, 2, -8)
        directionalLight.castShadow = true
        directionalLight.shadow.mapSize.width = 256
        directionalLight.shadow.mapSize.height = 256
        directionalLight.shadow.camera.top = 8
        directionalLight.shadow.camera.right = 8
        directionalLight.shadow.camera.bottom = -8
        directionalLight.shadow.camera.left = -8
        directionalLight.shadow.camera.near = 1
        directionalLight.shadow.camera.far = 20

        const doorLight = new THREE.PointLight('#ff7d46', 5)
        doorLight.position.set(0, 2.2, 2.5)
        this.house.add(doorLight)

        const ghost1 = new THREE.PointLight('#8800ff', 6)
        const ghost2 = new THREE.PointLight('#ff0088', 6)
        const ghost3 = new THREE.PointLight('#ff0000', 6)
        ghost1.castShadow = true
        ghost2.castShadow = true
        ghost3.castShadow = true

        ghost1.shadow.mapSize.width = 256
        ghost1.shadow.mapSize.height = 256
        ghost1.shadow.camera.far = 10

        this.ghosts.push(ghost1, ghost2, ghost3)

        this.scene.add(directionalLight, ambientLight, ghost1, ghost2, ghost3)
    }
}